import { Outlet, useNavigate } from "react-router-dom";
import {TENANT_SETTINGS_SIDER_LIST, TENANT_WORKFLOW_SIDER_LIST} from "../../../../data/configs/constants";
import { useSelector } from "react-redux";
import { useState } from "react";

import {Row, Col, Card, Badge, Typography, Collapse, Tag, Grid, List, theme, Menu} from "antd";
const { useBreakpoint } = Grid;

const { Panel } = Collapse;

export const Settings = () => {
  const {token} = theme.useToken()
  const navigate = useNavigate()
  const screens = useBreakpoint();
  const badgeOnSiderModule = useSelector(
    (state) => state.pageDetails.badgeOnSiderModule
  )
  const tenantInfo = useSelector((state) => state.overviewDetails.tenantInfo)
  const currentSiderModule = useSelector(
    (state) => state.pageDetails.currentSiderModule
  )
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const currentPage = useSelector((state) => state.pageDetails.currentPage)
  const mobile = useSelector((state) => state.pageDetails.deviceData.mobile)

  return (
    <Row gutter={8} justify={"space-around"} style={{overflow: "auto"}}>
      <Col
        md={5}
        xs={0}
      >
        <Typography.Title level={3} style={{margin:0}}>Settings</Typography.Title>
        <Typography.Text
          type="secondary"
          style={{display: "block", marginBottom: 16}}
        >
          Customize, manage user access and different AI & template settings
        </Typography.Text>
        <Menu
          style={{borderInlineEnd: "none", background: "transparent"}}
          selectedKeys={[currentSiderModule]}
          mode="vertical"
          items={TENANT_SETTINGS_SIDER_LIST.map((item) => ({
            key: item.appPage,
            icon: <Badge count={badgeOnSiderModule[item.appPage] || 0} offset={[5, 0]}>
              {item.icon}
            </Badge>,
            label: item.appPage,
            onClick: () => navigate(item.route.replace(":tenantId", tenantInfo.tenantId)),
          }))}
        />
      </Col>

      {/* Main Content */}
      <Col md={18} xs={24} style={{ height: "100%" }}>
        {/* Mobile Accordion Menu */}
        {
          screens.xs && (<div style={{ display: "block", marginBottom: 16 }}>
            <Collapse
              activeKey={mobileMenuOpen ? ["1"] : []}
              onChange={() => setMobileMenuOpen(!mobileMenuOpen)}
              expandIconPosition="end"
              style={{ backgroundColor: "#fff" }}
            >
              <Panel
                header={
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <i className="ri-fullscreen-line" />
                    <Typography.Text style={{ marginLeft: 8 }}>
                      {currentPage}
                    </Typography.Text>
                  </span>
                }
                key="1"
              >
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {TENANT_SETTINGS_SIDER_LIST.map((item) => (
                    <Tag
                      key={item.appPage}
                      color={item.appPage === currentPage ? "blue" : "default"}
                      icon={item.icon}
                      style={{
                        padding: "4px 12px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setMobileMenuOpen(false);
                        navigate(item.route.replace(":tenantId", tenantInfo.tenantId));
                      }}
                    >
                      {item.appPage}
                    </Tag>
                  ))}
                </div>
              </Panel>
            </Collapse>
          </div>)}

        <Card style={{height: "100%", overflow: "auto"}}>
          {/*<Typography.Title level={3} style={{margin:0}}>{currentSiderModule}</Typography.Title>*/}
          <Outlet />
        </Card>
      </Col>
    </Row>
  )
}